import React from 'react';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/solid';
import CustomerActionsMenu from '../actions/CustomerActionsMenu';

const CustomerTable = ({
  customers,
  clients,
  expandedIndex,
  onToggleStatus,
  onExpandCollpase,
  handleEdit,
  handleDownload,
  onCustomerSelected
}) => {
  const u = value => String(value ?? '').toUpperCase();

  return (
    <div className="hidden md:block overflow-x-auto">
      <table className="min-w-full bg-white table-auto rounded shadow text-sm">
        <thead className="bg-[#293686] text-white uppercase text-left">
          <tr>
            <th className="p-2">Code</th>
            <th className="p-2">Branch</th>
            <th className="p-2">Name</th>
            <th className="p-2">Contact</th>
            <th className="p-2">Email</th>
            <th className="p-2">Status</th>
            <th className="p-2">Clients</th>
            <th className="p-2">Actions</th>
          </tr>
        </thead>
        <tbody>
          {customers.length > 0 ? (
            <>
              {customers.map((c, idx) => (
                <React.Fragment key={idx}>
                  <tr className="border-t">
                    <td className="p-2  text-[#E91C24] font-bold">
                      <div className="cursor-pointer" onClick={() => onCustomerSelected(c)}>
                        {u(c.customer_code)}
                      </div>
                    </td>
                    <td className="p-2">{u(c.branch?.name)}</td>
                    <td className="p-2">{u(c.name)}</td>
                    <td className="p-2">{c.phone}</td>
                    <td className="p-2">{u(c.email)}</td>
                    <td
                      className="p-2 cursor-pointer text-blue-600 hover:underline"
                      onClick={() => onToggleStatus(idx)}
                    >
                      {c.is_active ? 'ACTIVE' : 'INACTIVE'}
                    </td>
                    <td className="p-2">
                      <button
                        onClick={() => onExpandCollpase(idx)}
                        className="flex items-center gap-1 text-sm text-blue-600"
                      >
                        {expandedIndex === idx ? (
                          <>
                            <ChevronUpIcon className="w-4 h-4" />
                            Hide
                          </>
                        ) : (
                          <>
                            <ChevronDownIcon className="w-4 h-4" />
                            View
                          </>
                        )}
                      </button>
                    </td>
                    <td className="p-2 text-sm">
                      <CustomerActionsMenu
                        customer={c}
                        onEdit={() => handleEdit(c)}
                        onDownload={() => handleDownload(c)}
                      />
                    </td>
                  </tr>
                  {expandedIndex === idx && (
                    <tr>
                      <td colSpan="7" className="p-2 bg-gray-50 text-sm text-gray-700">
                        <strong>Clients:</strong>{' '}
                        {c.clients?.length
                          ? c.clients.map((cl, i) => (
                              <span
                                key={i}
                                className="inline-block bg-blue-100 px-2 py-0.5 text-xs rounded mr-2"
                              >
                                {u(clients.filter(c => c.id == cl)[0].name)}
                              </span>
                            ))
                          : 'None'}
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </>
          ) : (
            <tr>
              <td colSpan="7" className="text-center text-gray-500 py-10">
                No customers found. Add one to get started.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default CustomerTable;
